module.exports = __webpack_public_path__ + "img/taoyuan-4.b9e8157c.jpg";